import { getError } from '@/src/utils'
import { CopyIcon } from '@icons'
import { useAppSelector } from '@store/hooks'
import { SideDrawer } from '@ui'
import { useState } from 'react'

type Props = {
  onClose: () => void
}

export const SyntaxCode = ({ onClose }: Props) => {
  const [isCopied, setIsCopied] = useState(false)
  const [index, setIndex] = useState<number>()
  const { document_template_variables } = useAppSelector(state => state.config)
  const handleCopySyntax = async (item: string, idx: number) => {
    await navigator.clipboard.writeText(item)
    try {
      setIsCopied(true)
      setIndex(idx)
      setTimeout(() => {
        setIsCopied(false)
        setIndex(undefined)
      }, 1000)
      setTimeout(() => {
        onClose()
      }, 1000)
    } catch (error) {
      getError(error)
    }
  }
  return (
    <SideDrawer onClose={onClose} title="Syntax Codes">
      <div className="overflow-auto divide-y p-8 flex flex-col">
        {document_template_variables?.map((item, idx) => (
          <div className="flex flex-col gap-2 p-2" key={item}>
            <p className="leading-[140%] text-base text-black">Add {item.replace(/_/g, ' ')}</p>
            <div className="flex gap-4">
              <p className="text-sm">{`{{${item}}}`}</p>
              <div className="relative">
                <CopyIcon onClick={() => handleCopySyntax(`{{${item}}}`, idx)} />
                {isCopied && idx === index && (
                  <div className="absolute bg-white shadow-md rounded-md text-green-500 px-3 py-1 bottom-0 -right-10 z-10">
                    Copied
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </SideDrawer>
  )
}
